import { useQueryInitialPOPDFLabelSet } from '@webapp/modules/purchasing/features/get-initial-po-pdf-label-set/models'

/**
 * Resolves the initially-active PO PDF label set (BHV-032): primary →
 * first available → null. The Feature Set seeds its active-set state from
 * `initialSet` until the user makes an explicit selection.
 */
export const useGetInitialPOPDFLabelSetPresenter = () => {
  const { initialSet, isLoading } = useQueryInitialPOPDFLabelSet()

  return {
    initialSet,
    isLoading,
  }
}
